import { mercadoPagoHttpClient } from "shared/services";


export interface PayloadToken {
  last_name: string;
  first_name: string;
  document_type: string;
  document_number: string;
  token: string;
  user_id: string;
  device_id: string;
  cardholder_name: string;
}


export const useCardRepository = () => {
  const saveCard = (payload: PayloadToken) =>
    mercadoPagoHttpClient.post("mercadopago-payment-zero-dollar-auth", payload, {
      headers: {
        'x-payment-key': 'SLl4trnJLt0jvBfu3er5Vt3WgMgun6dzsJIrrsN7baxAI9FHNfGqJJltxv',
      },
    });

  return {
    saveCard,
  };
};
